import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MdAccessTime from 'react-icons/lib/md/access-time';
import { formatNumber, getDecimals } from '../../service/market';

import css from '../../styles/instrument/changecomponent';

export default class ChangeComponent extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        change: PropTypes.number.isRequired,
        titleIsTime: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = { sign: css.neutral };

        this._setSign = change => {
            let sign;
            if (change) {
                sign = change >= 0 ? css.positive : css.negative;
            } else {
                sign = css.neutral;
            }

            this.setState({ sign });
        };
    }

    componentDidMount() {
        this._setSign(this.props.change);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.change !== nextProps.change) {
            this._setSign(nextProps.change);
        }
    }

    render() {
        const { title, change, titleIsTime } = this.props;

        return (
            <div className={[css.container, this.state.sign].join(' ')}>
                <span>{titleIsTime ? (<MdAccessTime />) : ''} {title}</span>
                <span>{formatNumber(change, getDecimals(change), true)}</span>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/ChangeComponent.js
 **/